/*
 * Package: WebVideo.VoteComment
 * Version: $Id$
 * Copyright (c) 2011-2013 Sergey Leonov
 */

function VoteComment() {}

VoteComment.resetCommentForm = function(form) {
  form.reset();
  jQuery(form.elements['vote_comment_rating']).trigger('change');
  jQuery(form.elements['vote_comment_comment']).trigger('change');
};

VoteComment.drawStar = function(el, block_id) {
  var _html = "";
  var k = parseInt(jQuery(el).val());
  for (var i=0; i<k; i++) {
    _html += '<i class="fa fa-star"></i>';
  }
  jQuery("#"+block_id).html(_html);
};

VoteComment.validateCommentForm = function(form, res_block_id) {
  //validation
  var msg = "";
  if (jQuery.trim(form.elements['vote_comment_comment'].value).length == 0) {
    msg = I18n.t("Comment is empty.");
  }
  if (msg.length != 0) {
    jQuery("#"+res_block_id).html("<span class=\"warning\">" + msg + "</span>");
    return false;
  }
  return true;
};

VoteComment.sendCommentForm = function(form, res_block_id, owner_id, owner_type, callbackFn) {
  if (!VoteComment.validateCommentForm(form, res_block_id)) return false;

  jQuery.ajax({
    "dataType": "jsonp",
    "type": "POST",
    "url": Config.exec + "/_ajaj-webvideo-gateway.jsp?callback=?",
    "data": {
      "command": "comment-create",
      "owner_id": owner_id,
      "owner_type": owner_type,
      "vote_comment_rating": form.elements['vote_comment_rating'] != undefined ? form.elements['vote_comment_rating'].value : 0,
      "vote_comment_comment": form.elements['vote_comment_comment'].value
    },
    "success": function(obj) {
      if (obj.res) {
        //reload
        jQuery("#"+res_block_id).html("");
        if (obj.msg && obj.alert) {
          alert(obj.msg);
        }
        if (typeof(callbackFn) == 'function') callbackFn();
      } else {
        //error
        jQuery("#"+res_block_id).html("<span class=\"warning\">" + obj.msg + "</span>");
      }
    },
    "error": function() {
      jQuery("#"+res_block_id).html("<span class=\"error\">" + I18n.t("Connection timeout. Please try later.") + "</span>");
    }
  });
  return false;
};


VoteComment.commentDelete = function (comment_id) {
  jQuery.getJSON(Config.exec+"/_ajaj-webvideo-gateway.jsp?callback=?", {"command": "comment-delete", "comment_id": comment_id}, function (obj) {
    if (!obj.res) {
      alert(obj.msg);
    } else {
      document.location.reload();
    }
  });
};
